/**
 * Traducciones del CHECKOUT: carrito, los tres pasos, métodos de pago y
 * las pantallas de confirmación.
 *
 * La CLAVE es el texto en español; el valor, su inglés.
 */
export const checkoutEn: Record<string, string> = {
  "+ Agregar una dirección nueva": "+ Add a new address",
  "Aplicar": "Apply",
  "Aquí recibirás la confirmación del pedido.": "This is where your order confirmation will arrive.",
  "Av. Siempre Viva 123, Col. Centro": "123 Evergreen Terrace, Suite 1",
  "Añade lo que quieras llevarte y vuelve aquí para cerrar tu pedido.": "Add what you'd like to take home and come back here to place your order.",
  "Cantidad: {{n}}": "Quantity: {{n}}",
  "Cargando tu carrito…": "Loading your cart…",
  "Con tarjeta pagas en línea al confirmar. Con transferencia o efectivo, validamos tu pago y tu pedido cambia de estado.": "With a card you pay online at checkout. With a transfer or cash, we verify your payment and your order moves forward.",
  "Confirma que todo esté como lo quieres antes de pagar.": "Make sure everything looks right before you pay.",
  "Continuar a revisión": "Continue to review",
  "Continuar al pago": "Continue to payment",
  "Coordina la entrega y el pago directamente con quien te vende. Al confirmar tu pago, tu pedido cambiará de estado.": "Arrange delivery and payment directly with your seller. Once your payment is confirmed, your order moves forward.",
  "Corregir datos": "Edit details",
  "Correo electrónico": "Email",
  "Cupón": "Coupon",
  "Código del cupón": "Coupon code",
  "Datos de contacto": "Contact details",
  "Dirección de entrega": "Delivery address",
  "El pago con tarjeta aún no está disponible": "Card payments aren't available yet",
  "El pago se canceló": "The payment was cancelled",
  "Entrar a mi panel de franquiciataria": "Go to my franchise panel",
  "Entrega en": "Delivered to",
  "Entrega tu pago en efectivo a un súper socio. En cuanto valide tu pago, tu compra se aprueba y tu pedido cambia de estado.": "Hand your cash payment to a super partner. As soon as they verify it, your purchase is approved and your order moves forward.",
  "Estamos validando tu pago. En cuanto se apruebe, tu Franquicia Digital se activa y AQUÍ se abre tu panel de franquiciataria.": "We're verifying your payment. Once it's approved, your Digital Franchise activates and your franchise panel opens RIGHT HERE.",
  "Estamos validando tu pago. En cuanto se apruebe, tu pedido cambiará de estado.": "We're verifying your payment. Once it's approved, your order will move forward.",
  "Franquicia Digital (1 año)": "Digital Franchise (1 year)",
  "Guarda tu folio: es como daremos seguimiento a tu pedido.": "Keep your order number: it's how we'll track your order.",
  "Haz tu transferencia y CONSERVA el comprobante: con él validaremos tu pago y tu pedido cambiará de estado.": "Make your transfer and KEEP the receipt: we'll use it to verify your payment and move your order forward.",
  "Los costos de envío y tiempos de entrega se coordinan al confirmar tu pago.": "Shipping costs and delivery times are arranged once your payment is confirmed.",
  "No se hizo ningún cargo.": "You weren't charged.",
  "No se pudo cerrar el pedido. Inténtalo otra vez.": "We couldn't complete your order. Please try again.",
  "No se pudo validar el cupón": "We couldn't validate that coupon",
  "Nombre completo": "Full name",
  "Paga con el enlace seguro de Stripe": "Pay through Stripe's secure link",
  "Pagar ahora": "Pay now",
  "Pagarás en efectivo": "You'll pay in cash",
  "Pagarás por transferencia": "You'll pay by bank transfer",
  "Para contactarte sobre el envío.": "So we can reach you about the delivery.",
  "Pasos del pedido": "Order steps",
  "Portón azul, entre calles, indicaciones para quien entrega": "Blue gate, cross streets, notes for the courier",
  "Producto no disponible": "Product unavailable",
  "Quitar el cupón": "Remove coupon",
  "Realizar pedido": "Place order",
  "Recibe": "Recipient",
  "Referencias (opcional)": "Landmarks (optional)",
  "Revisa tu pedido": "Review your order",
  "Se guardan en tu perfil: elige una o agrega otra.": "These are saved to your profile: pick one or add another.",
  "Seguir comprando": "Keep shopping",
  "Todavía no hay una cuenta registrada para transferencias: escríbenos por WhatsApp y te la damos.": "There's no bank account on file for transfers yet — message us on WhatsApp and we'll send you the details.",
  "Total": "Total",
  "Transfiere a la cuenta de la tienda y comparte tu comprobante con quien te vende: al registrarlo, tu pedido cambiará de estado.": "Transfer to the store's account and share your receipt with your seller: once it's recorded, your order moves forward.",
  "Tu carrito": "Your cart",
  "Tu nombre tal como aparece en tu identificación.": "Your name as it appears on your ID.",
  "Tu pago quedó validado. Tu tienda y tu panel te esperan.": "Your payment is verified. Your store and your panel are ready.",
  "Tu pago se validará manualmente: en cuanto lo confirmemos, tu pedido cambiará de estado.": "Your payment will be verified by hand: as soon as we confirm it, your order moves forward.",
  "Tu pedido quedó registrado. Te contactaremos para completar el pago, o puedes pagar por transferencia y enviarnos tu comprobante.": "Your order is placed. We'll reach out to complete the payment, or you can pay by transfer and send us your receipt.",
  "Tu pedido {{folio}} sigue registrado. Puedes pagarlo por transferencia y enviar tu comprobante, o intentar de nuevo desde donde lo creaste.": "Your order {{folio}} is still on file. You can pay it by transfer and send your receipt, or try again from where you created it.",
  "Usaremos esta información para confirmar tu pedido.": "We'll use this to confirm your order.",
  "Verificar de nuevo": "Check again",
  "Volver a revisión": "Back to review",
  "oficial": "official",
  "pago": "payment",
  "pedido": "order",
  "{{monto}} de descuento": "{{monto}} off",
  "{{n}}% de descuento": "{{n}}% off",
  "¡Listo! Tu pedido ya está validado.": "All set! Your order is verified.",
  "¡Recibimos tu pago!": "We got your payment!",
  "¡Tu Franquicia Digital está activa!": "Your Digital Franchise is active!",
  "¿Cómo quieres pagar?": "How would you like to pay?",
  "¿Tienes un cupón?": "Have a coupon?",
  // El envío en el checkout (13-oct-2026)
  "¿Cómo quieres recibirlo?": "How would you like to receive it?",
  "Recomendado": "Recommended",
  "Llega en 1 día hábil": "Arrives in 1 business day",
  "Llega en {{n}} días hábiles": "Arrives in {{n}} business days",
  "Envío": "Shipping",
  "Calculando…": "Calculating…",
  "Se calcula con tu dirección": "Calculated from your address",
  "Calculando el envío…": "Calculating shipping…",
  "No pudimos calcular el envío. Revisa la dirección e inténtalo otra vez.": "We couldn't calculate shipping. Check the address and try again.",
  "Reintentar": "Try again",
  "El costo y el tiempo de envío se coordinan al confirmar tu pago.": "Shipping cost and time are arranged once your payment is confirmed.",
};
